#import "../../../../common/graphql/TagEntityFields.graphql"

mutation TagUpdate($input: TagUpdateInput!) {
  tagUpdate(input: $input) {
    tag {
      ...TagEntityFields
    }
  }
}
